/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JobMatchPagedData } from '../../models/job-match-paged-data';

export interface GetJobPostingMatches$Params {
  profileId: string;
  PageNumber?: number;
  PageSize?: number;
}

export function getJobPostingMatches(http: HttpClient, rootUrl: string, params: GetJobPostingMatches$Params, context?: HttpContext): Observable<StrictHttpResponse<JobMatchPagedData>> {
  const rb = new RequestBuilder(rootUrl, getJobPostingMatches.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JobMatchPagedData>;
    })
  );
}

getJobPostingMatches.PATH = '/studentprofile/{profileId}/match/jobposting';
